import Vue from 'vue';
import BSidebarUI from '../../components/UI/BSidebarUI'

Vue.component('BSidebarUI', BSidebarUI)
